import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({
      to: "/fleet",
      replace: true,
      search: (prev: Record<string, unknown>) => prev,
    }) as unknown;
  },
});
